<template>
  <section class="vs">
    <div class="container">
      <a-typography-title :level="1">
        智能运维 vs. 传统运维
      </a-typography-title>
      <div class="box_list">
        <i v-for="i in 4"
           class="i_icon" :class="`i_${i}`" />
        <a-row class="title">
          <a-col :span="6" />
          <a-col :span="9">
            传统运维
          </a-col>
          <a-col :span="9">
            智能运维
          </a-col>
        </a-row>
        <a-row v-for="item in expand.list"
               class="item">
          <a-col :xs="24" :lg="6">
            <span>{{ item.title }}</span>
          </a-col>
          <a-col :xs="24" :lg="9">
            <p>传统运维</p>
            <span v-for="v in item.tradition">
              {{ v }}
            </span>
          </a-col>
          <a-col :xs="24" :lg="9">
            <p>智能运维</p>
            <span v-for="v in item.intelligent">
              {{ v }}
            </span>
          </a-col>
        </a-row>
      </div>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'plan_detail',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: '资源及权限管理',
            tradition: [
              '手动管理资源，耗时长、易误操作',
              '不同平台学习成本高',
              '规模大时容易管理混乱'
            ],
            intelligent: [
              '系统统一管理资源',
              '学习成本较低',
              '配置模板化，效率更高',
              '较少误操作'
            ]
          },
          {
            title: '发布部署',
            tradition: [
              '手动操作耗时长、易误操作',
              '需要配置大量参数'
            ],
            intelligent: [
              '系统统一调度资源',
              '发布部署自动化',
              '配置标准化',
              '操作时间短'
            ]
          },
          {
            title: '业务保障',
            tradition: [
              '日常保障监控告警',
              '人工判断易影响性能',
              '人工执行扩缩容等重要操作',
              '24小时值守，人力成本高'
            ],
            intelligent: [
              '决策指标精准体现业务现状',
              '故障处理标准化、自动化',
              '扩缩容、回滚自动化',
              '一键触发故障处理动作'
            ]
          },
          {
            title: '备份与迁移',
            tradition: [
              '数据迁移工具稳定性不足',
              '依赖网络带宽、耗时长',
              '跨云迁移操作难度大'
            ],
            intelligent: [
              '10分钟内跨域传输1TB数据',
              '通过公网低峰期低成本迁移',
              '支持多云算力调度',
              '跨云业务迁移简单高效'
            ]
          },
          {
            title: '成本合规',
            tradition: [
              '手工导入导出账单',
              '对账依赖手工或脚本工具',
              '难以保障对账准确性',
              '跨平台多账号对账耗时长'
            ],
            intelligent: [
              '账号多平台数据汇总',
              '多维度账单数据',
              '一键导出对账表格',
              '工具化保证准确性且效率高'
            ]
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}page/public/';
@image: '@{src_image}page/planOperation/';
@border: 1px solid @color_15;

.vs {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.box_list {
  position: relative;
  margin: @margin 0 0;
  
  .i_icon {
    display: block;
    position: absolute;
    .bg('@{image}vs_decorate.png', 35px, 171px, true);
    pointer-events: none;
    
    &.i_1 {
      top: 150px;
      left: 700px;
      .transform(scale(0.8));
    }
    
    &.i_2 {
      top: 400px;
      left: 340px;
      .transform(scale(0.6));
    }
    
    &.i_3 {
      right: 30px;
      bottom: 0;
    }
    
    &.i_4 {
      right: 80px;
      bottom: -30px;
      .transform(scale(0.6));
    }
  }
  
  .ant-row {
    .ant-col {
      position: relative;
      
      &:nth-child(1) {
        background: @color_7;
        background-size: cover !important;
      }
    }
  }
  
  .title {
    .font(center, @text_big+20px, @color_white, @text_big, true);
    
    .ant-col {
      &:nth-child(1) {
        border: @border;
      }
      
      &:nth-child(2) {
        .bg('@{image}vs_bg_1.jpg');
      }
      
      &:nth-child(3) {
        .bg('@{image}vs_bg_2.jpg');
      }
    }
  }
  
  .item {
    @wh: 50px;
    
    .loop(@i) when (@i<=5) {
      &:nth-child(@{i}) {
        .ant-col:nth-child(1)::before {
          background-position-x: -(-1+@i)*@wh;
        }
      }
      .loop(@i+1);
    }
    .loop(1);
    
    .ant-col {
      @iwh: 16px;
      border: @border;
      border-top: none;
      
      &:nth-child(1) {
        padding: 20px 0 30px;
        .font(center, @text_big, @color_12, @text_big, true);
        
        &::before {
          content: '';
          display: block;
          width: @wh;
          height: @wh;
          margin: 0 auto 5px;
          .bg('@{image}vs_icon.png', @wh*5, @wh);
        }
      }
      
      &:nth-child(2),
      &:nth-child(3) {
        display: flex;
        border-left: none;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        
        p {
          display: none;
          .position(left);
          width: 30px;
          .font(center, @text+2px, @color_white, @text, true);
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        
        span {
          display: block;
          position: relative;
          width: 280px;
          padding-left: 25px;
          margin: 0 auto 10px;
          .font(left, @text, @color_13, @text);
          
          &:last-child {
            margin: 0 auto;
          }
          
          &::before {
            content: '';
            display: block;
            .position(absolute, 0, auto, auto, 0);
            margin: auto 0;
            border-radius: 50%;
          }
        }
      }
      
      &:nth-child(2) {
        p {
          .bg('@{image}vs_bg_1.jpg', 100%, 100%);
        }
        
        span::before {
          .bg('@{image}vs_icon_1.png', @iwh, @iwh, true);
        }
      }
      
      &:nth-child(3) {
        p {
          .bg('@{image}vs_bg_2.jpg', 100%, 100%);
        }
        
        span::before {
          .bg('@{image}vs_icon_2.png', @iwh, @iwh, true);
        }
      }
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .vs {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .box_list {
    margin: @margin_mo 0 0;
    
    .i_icon {
      display: none;
    }
    
    .ant-row {
      margin: @margin_mo 0 0;
      
      &:first-child {
        margin: 0;
      }
      
      &.title {
        display: none;
      }
      
      &.item {
        @wh: 25px;
        
        .loop(@i) when (@i<=5) {
          &:nth-child(@{i}) {
            .ant-col:nth-child(1)::before {
              background-position-x: -(-1+@i)*@wh;
            }
          }
          .loop(@i+1);
        }
        .loop(1);
        
        .ant-col {
          border: @border !important;
          
          &:nth-child(1) {
            padding: 10px 0;
            .font(center, @wh, @color_12, @text_big_mo, true);
            
            &::before {
              display: inline-block;
              width: @wh;
              height: @wh;
              margin: 0 5px 0 0;
              .bg('@{image}vs_icon.png', @wh*5, @wh);
              vertical-align: top;
            }
          }
          
          &:nth-child(2),
          &:nth-child(3) {
            padding: 20px 20px 20px 50px;
            border-top: none !important;
            
            p {
              display: flex;
            }
            
            span {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>